/** Sri Lankan mobile-number format validation; not proof of SIM ownership. */
export function normalizeSriLankanMobile(input:string):string|null {
  const raw=input.trim().replace(/[\s().-]/g,'')
  const national=raw.startsWith('+94')?'0'+raw.slice(3):raw.startsWith('94')?'0'+raw.slice(2):raw
  if(!/^07\d{8}$/.test(national))return null
  return '+94'+national.slice(1)
}
export const sriLankanMobileHint='Enter a Sri Lankan mobile number: 07XXXXXXXX or +947XXXXXXXX.'
